/**
 * 与后端默认密码策略一致（最终以服务端校验为准）。
 * 可用 GET /api/auth/password-policy 拉取当前配置摘要。
 */
export const PASSWORD_MIN_LENGTH = 10

export const PASSWORD_POLICY_HINT =
  `至少 ${PASSWORD_MIN_LENGTH} 位，需含大写、小写字母、数字及特殊字符（如 !@#$%^&*），且不可包含完整用户名`

/**
 * @param {string} password
 * @param {string} [username]
 * @returns {string|null} 错误文案，通过返回 null
 */
export function validatePasswordClient(password, username) {
  if (!password || password.length < PASSWORD_MIN_LENGTH) {
    return `密码至少 ${PASSWORD_MIN_LENGTH} 位`
  }
  if (password.length > 128) return '密码过长'
  if (!/[A-Z]/.test(password)) return '需包含大写字母'
  if (!/[a-z]/.test(password)) return '需包含小写字母'
  if (!/\d/.test(password)) return '需包含数字'
  if (!/[!@#$%^&*()_+\-=[\]{}|;:,.<>?/~`]/.test(password)) return '需包含特殊字符'
  const u = (username || '').trim().toLowerCase()
  if (u.length >= 2 && password.toLowerCase().includes(u)) {
    return '密码不能包含完整用户名'
  }
  return null
}
